import { FC } from "react";
import { Link } from "react-router";

import { Logo } from "./components";

import type { LogoProps } from "./components";

export type CarburateLogoProps = {
  to?: string;
} & LogoProps;

export const CarburateLogo: FC<CarburateLogoProps> = ({ title, to, ...props }) => {
  if (to) {
    return (
      <Link to={to} title={title}>
        <Logo {...props} />
      </Link>
    );
  }

  return <Logo title={title} {...props} />;
};
